<div class="sr-app-light:bg-white vl-app-light:bg-white gl-light-dark:pt-0 sticky top-0 z-[1] w-full bg-white pt-4">
    <div class="gl-light-dark:h-16 gl-light:bg-primary flex items-center px-4">
        <ion-button
            class="no-padding var-app-light-dark:text-primary z-10 text-xs font-bold normal-case text-secondary dark:text-contrast-yellow print:hidden"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="redirectToJourneyPlanner()"
            fill="clear">
            <ion-icon
                class="vl-app-light:text-xl mr-1 text-xl dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
        </ion-button>

        <div class="align-center flex flex-1 items-center justify-center">
            <h1
                class="vl-app-light-dark:font-bold orb-app-light-dark:font-bold left-0 mx-0 w-full text-base font-semibold">
                {{ 'JOURNEY_PLANNER_HEADER' | translate }}
            </h1>
        </div>

        <div class="flex items-center justify-end">
            <button
                class="var-app-light-dark:max-h-[2rem] h-8 w-8 dark:filter-yellow"
                #favoriteButton
                *ngIf="this.env.JOURNEY_PLANNER?.SHOW_FAVORITES && currentPlan"
                [attr.aria-label]="
                    isIos
                        ? ('FAVORITE' | translate)
                        : isLocationExistInFavoriteList
                          ? ('REMOVE_FAVORITE_JOURNEY' | translate)
                          : ('ADD_FAVORITE_JOURNEY' | translate)
                "
                [attr.aria-checked]="isIos ? isLocationExistInFavoriteList : null"
                [attr.role]="isIos ? 'switch' : 'button'"
                (click)="addFavoritePath()"
                slot="icon"
                fill="clear">
                <ion-icon
                    class="vl-app-light:text-xl var-app-light-dark:text-[2rem] var-app-light:text-primary orb-app-light-dark:text-[2rem] text-2xl text-secondary dark:text-contrast-yellow"
                    [src]="
                        isLocationExistInFavoriteList
                            ? (assetsPath$ | async) + '/img/journey-planner/favorite.svg'
                            : (assetsPath$ | async) + '/img/journey-planner/not-favorite.svg'
                    "></ion-icon>
            </button>
        </div>
        <span class="sr-only" #dummyFocus tabindex="0"></span>
    </div>
    <div class="gl-light:bg-primary shadow-md">
        <rwidget-journey-planner-search (selectTime)="setSelectedTime($event)"></rwidget-journey-planner-search>
    </div>
</div>

<div class="relative flex-grow overflow-y-scroll">
    <div
        class="bg-white dark:bg-contrast-black"
        *ngIf="(plan$ | async).loading || isProcessingSharedItinerary; else loadedTemplate">
        <div class="flex px-2 pt-2">
            <ridango-ui-skeleton-loader class="w-full" height="6.5rem" count="6"> </ridango-ui-skeleton-loader>
        </div>
    </div>
    <ul class="flex flex-col" aria-busy="false">
        <ng-template #loadedTemplate>
            <div>
                <ng-container
                    *ngIf="
                        search?.destination && search?.origin && (displayedItineraries || displayedGroupItineraries)
                    ">
                    <li
                        class="ml-4 box-border flex h-12 items-center justify-between border-b border-solid border-opacity-10 dark:border-contrast-yellow">
                        <h2
                            class="vl-app-light:font-bold text-base font-semibold leading-5 text-black dark:text-contrast-yellow">
                            {{ 'JOURNEY_RESULTS' | translate }}
                        </h2>
                        <ion-button
                            [attr.aria-label]="'REFRESH' | translate"
                            (click)="refreshData()"
                            size="small"
                            fill="clear">
                            <ion-icon
                                class="var-app-light-dark:text-black text-3xl text-secondary dark:filter-yellow"
                                title="{{ 'REFRESH' | translate }}"
                                aria-label="{{ 'REFRESH' | translate }}"
                                src="{{ assetsPath$ | async }}/img/journey-planner/icon-refresh.svg"></ion-icon
                        ></ion-button>
                    </li>

                    <div
                        class="flex items-center justify-center bg-[#F4F5F8] dark:bg-contrast-black"
                        *ngIf="
                            search?.destination &&
                            search?.origin &&
                            showEarlier &&
                            !(plan$ | async).loading &&
                            !showError()
                        ">
                        <ion-button
                            class="var-app-light-dark:normal-case var-app-light:text-primary orb-app-light-dark:normal-case cursor-pointer py-5 text-center text-base font-semibold text-secondary dark:text-contrast-yellow"
                            [class.normal-case]="env.REMOVE_UPPERCASE"
                            [attr.aria-label]="'SHOW_MORE_EARLIER_ELLIPSIS' | translate"
                            (click)="showMoreClickBefore()"
                            fill="clear">
                            <ion-icon
                                class="mr-1 text-secondary dark:text-contrast-yellow"
                                *ngIf="env.JOURNEY_PLANNER?.SHOW_ICON_FOR_SHOW_MORE"
                                src="{{ assetsPath$ | async }}/img/explore/icon-arrow-down-circle.svg">
                            </ion-icon>
                            {{ 'SHOW_MORE_EARLIER_ELLIPSIS' | translate }}
                        </ion-button>
                    </div>

                    <li
                        class="flex-column vl-app-light:bg-grey-white_smoke sr-app-light:bg-grey-white_smoke flex gap-6">
                        <ng-container *ngIf="isGroupedRoutes; else nonGroupedRoutes">
                            <div
                                class="bg-white shadow-md"
                                *ngFor="let departureGroup of displayedGroupItineraries; let lastGroup = last">
                                <ng-container *ngIf="departureGroup.date">
                                    <div
                                        class="px-4 py-3 text-xs font-bold leading-4 text-[#414141] dark:text-contrast-yellow">
                                        {{
                                            isDate(departureGroup.date)
                                                ? (departureGroup.date | date: env.PRIMARY_DATE_FORMAT || '')
                                                : (departureGroup.date | uppercase)
                                        }}
                                    </div>
                                    <div class="border-ironside_grey-100 border-t border-solid"></div>
                                </ng-container>

                                <ng-container
                                    [ngTemplateOutlet]="itineraryBlock"
                                    [ngTemplateOutletContext]="{ itineraries: departureGroup.itineraries }">
                                </ng-container>
                            </div>
                        </ng-container>

                        <ng-template #nonGroupedRoutes>
                            <div class="bg-white shadow-md">
                                <ng-container
                                    [ngTemplateOutlet]="itineraryBlock"
                                    [ngTemplateOutletContext]="{ itineraries: displayedItineraries }">
                                </ng-container>
                            </div>
                        </ng-template>
                    </li>
                </ng-container>

                <ng-container *ngIf="showHistory()">
                    <rwidget-search-recently-journeys></rwidget-search-recently-journeys>
                </ng-container>

                <ng-container *ngIf="showError()">
                    <div class="m-4 text-center">
                        <div class="vl-app-light:text-old_silver-lighter my-4 text-grey-dark dark:text-contrast-yellow">
                            <svg
                                width="42"
                                height="43"
                                viewBox="0 0 42 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M26.2578 29.8187L39.0821 42.643L41.9105 39.8145L29.0862 26.9902L26.2578 29.8187Z"
                                    fill="currentColor" />
                                <path
                                    d="M17.5111 35.8621C7.82785 35.8621 0 27.8223 0 17.931C0 8.03978 7.82785 0 17.5111 0C27.1943 0 35.0222 8.03978 35.0222 17.931C35.0222 27.8223 27.1943 35.8621 17.5111 35.8621ZM17.5111 31.8621C24.9609 31.8621 31.0222 25.6367 31.0222 17.931C31.0222 10.2254 24.9609 4 17.5111 4C10.0613 4 4 10.2254 4 17.931C4 25.6367 10.0613 31.8621 17.5111 31.8621Z"
                                    fill="currentColor" />
                            </svg>
                        </div>
                        <ng-container *ngIf="isPlannerErrorMessage((plan$ | async).error?.message); else genericError">
                            <p>{{ (plan$ | async).error.message | translate }}</p>
                        </ng-container>
                        <ng-template #genericError>
                            <p>{{ 'JOURNEY_PLANNER_NO_TRIPS_FOUND' | translate }}</p>
                        </ng-template>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </ul>
    <div class="flex items-center justify-center bg-[#F4F5F8] dark:bg-contrast-black">
        <ion-button
            class="var-app-light-dark:normal-case var-app-light:text-primary orb-app-light-dark:normal-case cursor-pointer py-5 text-center text-base font-semibold text-secondary dark:text-contrast-yellow"
            *ngIf="
                search?.destination &&
                search?.origin &&
                showMoreAfter() &&
                !isProcessingSharedItinerary &&
                !(plan$ | async).loading &&
                !showError()
            "
            [class.normal-case]="env.REMOVE_UPPERCASE"
            [attr.aria-label]="'SHOW_MORE_ELLIPSIS' | translate"
            (click)="showMoreClickAfter()"
            fill="clear">
            <ion-icon
                class="mr-1 text-secondary dark:text-contrast-yellow"
                *ngIf="env.JOURNEY_PLANNER?.SHOW_ICON_FOR_SHOW_MORE"
                src="{{ assetsPath$ | async }}/img/explore/icon-arrow-down-circle.svg"></ion-icon>
            {{ 'SHOW_MORE_ELLIPSIS' | translate }}
        </ion-button>
    </div>
</div>

<ng-template #itineraryBlock let-itineraries="itineraries">
    <ng-container *ngFor="let itinerary of itineraries; let i = index">
        <div>
            <button
                class="w-full p-0"
                [ngClass]="{ 'border-t border-solid border-opacity-10 dark:border-contrast-yellow': i > 0 }"
                (click)="openItineraryDetailsView(itinerary)">
                <rwidget-journey-itinerary [currentTime]="currentTime$ | async" [itinerary]="itinerary">
                </rwidget-journey-itinerary>
            </button>
        </div>
    </ng-container>
</ng-template>
